import {
  EPreferences,
  IPreference,
} from "@rentiohq/shared-frontend/dist/types/preferences.types";
import { showAlert } from "@rentiohq/shared-frontend/dist/utils/alert/alert.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";

export const getParsedAnnouncement = (preferences: IPreference[]) => {
  const generalAnnouncementPreference =
    // TODO: Remove after array check after 2026 Q1 release
    (Array.isArray(preferences) ? preferences : []).find(
      preference => preference.key === EPreferences.Announcement,
    );

  if (!generalAnnouncementPreference?.json) {
    return;
  }

  try {
    const parsedJson = JSON.parse(generalAnnouncementPreference?.json);

    return parsedJson;
  } catch (error) {
    showAlert({
      message: (error as any) || getLocalizedText("general.error"),
      type: "error",
    });
  }
};
